import React from 'react';
import './styles.css'; // Menggunakan CSS utama

const PageHeader = ({ title, subtitle, imageUrl }) => {
  // Style dinamis untuk latar belakang
  const headerStyle = imageUrl
    ? { backgroundImage: `linear-gradient(rgba(0, 20, 60, 0.7), rgba(0, 20, 60, 0.7)), url('${imageUrl}')` }
    : {};

  return (
    <header className="page-header" style={headerStyle}>
      <div className="container">
        {title && <h1>{title}</h1>}
        {subtitle && <p>{subtitle}</p>}
      </div>
    </header>
  );
};

export default PageHeader;